import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function fetchDesenvolvimento(satNum) {
  const base = getBase();
  if (!base || !satNum) return null;
  try {
    const res = await axios.get(base + '/desenvolvimento/chamado/' + satNum, { headers: getAuthHeaders(), timeout: 15000 });
    return res?.data ?? null;
  } catch (err) {
    if (err?.response?.status === 501) return null;
    console.error('Erro ao carregar desenvolvimento:', err);
    return null;
  }
}

export async function addVinculo(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/desenvolvimento/vinculo', body, { headers: getAuthHeaders(), timeout: 15000 });
}

export async function removeVinculo(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/desenvolvimento/vinculo/' + id, { headers: getAuthHeaders(), timeout: 15000 });
}

export async function fetchChamadosDoArquivo(arquivoId) {
  const base = getBase();
  if (!base || !arquivoId) return [];
  try {
    const res = await axios.get(base + '/desenvolvimento/arquivo/' + arquivoId + '/chamados', { headers: getAuthHeaders(), timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    return [];
  }
}

// Lista de artigos da base de conhecimento (para o seletor de vínculo).
export async function fetchArtigosKB() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/base-conhecimento', { headers: getAuthHeaders(), timeout: 15000 });
    const data = res?.data;
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.artigos)) return data.artigos;
    if (data && Array.isArray(data.data)) return data.data;
    return [];
  } catch (err) {
    return [];
  }
}
